// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + ({"1702":"4d34c113","7222":"18394c63","7937":"de4f6177"}[chunkId] || chunkId) + "." + {"1702":"2e2f29e9983cb9e0","5763":"03523fbb86fe12ad","6893":"8e3b3d2bec9dc34e","6974":"8455519e86ab7fe8","7222":"1bdb7d06493eb505","7937":"da0a4ae7eb5fb6f7"}[chunkId] + ".js";
};